import { render, staticRenderFns } from "./MTRealtimeList.vue?vue&type=template&id=64200c0f&scoped=true&"
import script from "./MTRealtimeList.vue?vue&type=script&lang=js&"
export * from "./MTRealtimeList.vue?vue&type=script&lang=js&"
import style0 from "./MTRealtimeList.vue?vue&type=style&index=0&id=64200c0f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64200c0f",
  null
  
)

export default component.exports